// This file has js ext. and such module format, because it's used by webpack.
const brandsConfig = {
    rc_us: {
        id: '1210',
        proDomain: 'v.ringcentral.com',
        opsDomain: 'v.ops.ringcentral.com',
    },
    atos: {
        id: '2020',
        proDomain: 'video.unifyoffice.com',
        opsDomain: 'video-atos.eurouat.ringcentral.com',
    },
    telekom: {
        id: '2030',
        proDomain: 'telekom.video.ringcentral.com',
        opsDomain: 'video-telekom.eurouat.ringcentral.com',
    },
    dtatos: {
        id: '2040',
        proDomain: 'unifyoffice-telekom.video.ringcentral.com',
        opsDomain: 'video-unifyoffice-telekom.eurouat.ringcentral.com',
    },
    rainbow: {
        id: '2110',
        proDomain: 'video.rainbowoffice.com',
        opsDomain: 'video-rainbowoffice.eurouat.ringcentral.com',
    },
    verizon: {
        id: '2210',
        proDomain: 'verizon.video.ringcentral.biz',
        opsDomain: 'verizon.video.uat.ringcentral.com',
    },
    att: {
        id: '3420',
        proDomain: 'meetings.officeathand.att.com',
        opsDomain: 'v.uat.ringcentral.com',
    },
    ecotel: {
        id: '4210',
        proDomain: 'ecotel.video.ringcentral.com',
        opsDomain: 'video-ecotel.eurouat.ringcentral.com',
    },
    eastlink: {
        id: '4610',
        proDomain: 'eastlink.video.ringcentral.com',
        opsDomain: 'video-eastlink.ops.ringcentral.com',
    },
    versatel: {
        id: '4710',
        proDomain: '1und1.video.ringcentral.com',
        opsDomain: 'video-1und1.eurouat.ringcentral.com',
    },
    mcm: {
        id: '4810',
        proDomain: 'symphony.video.ringcentral.com',
        opsDomain: 'video-symphony.ops.ringcentral.com',
    },
    frontier: {
        id: '4910',
        proDomain: 'frontier.video.ringcentral.com',
        opsDomain: 'video-frontier.ops.ringcentral.com',
    },
    avaya: {
        id: '6010',
        proDomain: 'video.cloudoffice.avaya.com',
        opsDomain: 'v-avaya.ops.ringcentral.com',
    },
    vodafone: {
        id: '7010',
        proDomain: 'video.vodafonebusiness.ringcentral.com',
        opsDomain: 'video-vodafonebusiness.eurouat.ringcentral.com',
    },
    telus: {
        id: '7310',
        proDomain: 'video.businessconnect.telus.com',
        opsDomain: 'video-telus.ops.ringcentral.com',
    },
    bt: {
        id: '7710',
        proDomain: 'video.cloudwork.bt.com',
        opsDomain: 'video-bt.eurouat.ringcentral.com',
    },
    sunrise: {
        id: '2050',
        proDomain: 'sunrise.video.ringcentral.com',
        opsDomain: 'video-sunrise.eurouat.ringcentral.com',
    },
    spectrumbusiness: {
        id: '5110',
        proDomain: 'spectrumbusiness.video.ringcentral.com',
        opsDomain: 'video-spectrumbusiness.ops.ringcentral.com',
    },
    spectrumenterprise: {
        id: '5210',
        proDomain: 'spectrumenterprise.video.ringcentral.com',
        opsDomain: 'video-spectrumenterprise.ops.ringcentral.com',
    },
    risea: {
        id: '3000',
        proDomain: 'v.risea.ringcentral.com',
        opsDomain: 'video-risea.ops.ringcentral.com',
    },
    risei: {
        id: '2000',
        proDomain: 'v.risei.ringcentral.com',
        opsDomain: 'video-risei.ops.ringcentral.com',
    },
    salt: {
        id: '2000.Salt',
        proDomain: 'v.salt.ringcentral.com',
        opsDomain: 'video-salt.eurouat.ringcentral.com',
    },
    empower: {
        id: '4000',
        proDomain: 'v.empower.ringcentral.com',
        opsDomain: 'video-empower.eurouat.ringcentral.com',
    },
};

const brandsList = Object.keys(brandsConfig);

module.exports = {
    brandsConfig,
    brandsList,
};
